import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// components
import NumberFormat from 'react-number-format';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const CurrencyInput = ({ value, disabled, onChange, decimalScale = 2, additionalBlurMethod, ...inputProps }) => {
  let input = null;

  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (input) {
      input.focus();
      input.select();
    }
  }, [focused]);

  return (
    <React.Fragment>
      {focused && (
        <input
          {...inputProps}
          value={value}
          disabled={disabled}
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onBlur={() => {
            // parse value into numnber, fix decimals to 2, and fire onchange with resulting number
            const newVal = parseFloat(parseFloat(value).toFixed(2));

            // validate the field to ensure its a number
            if (newVal.toString() === 'NaN') {
              onChange(0);
            } else if (onChange) {
              onChange(newVal);
            }
            setFocused(false);
            if (additionalBlurMethod) {
              additionalBlurMethod();
            }
          }}
          ref={i => (input = i)}
        />
      )}
      {!focused && (
        <NumberFormat
          {...inputProps}
          value={value}
          thousandSeparator={true}
          prefix={'$'}
          decimalScale={decimalScale}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          fixedDecimalScale
        />
      )}
    </React.Fragment>
  );
};

CurrencyInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  decimalScale: PropTypes.number
};

export default CurrencyInput;
